module.exports = __webpack_public_path__ + "media/images/athletes/2689-196e6304c2a2844a497389a32fcb1626.png";